import { PERMISSIONS, REPORTS_PERMISSIONS } from '../../../Enums/permission.enum';
import { HomeDestination } from '../Interfaces/home-destination.interface';

export const HOME_DESTINATIONS: readonly HomeDestination[] = [
  {
    key: 'users',
    icon: 'group',
    labelKey: 'app.home.destinations.users.title',
    descriptionKey: 'app.home.destinations.users.description',
    routerLink: ['/users'],
    permission: PERMISSIONS.INTUNE_USER_READ,
    entitlement: 'user_management',
  },
  {
    key: 'devices',
    icon: 'devices',
    labelKey: 'app.home.destinations.devices.title',
    descriptionKey: 'app.home.destinations.devices.description',
    routerLink: ['/devices'],
    permission: PERMISSIONS.DEVICE_READ,
    entitlement: 'device_management',
  },
  {
    key: 'autopilot_devices',
    icon: 'laptop_windows',
    labelKey: 'app.home.destinations.autopilot_devices.title',
    descriptionKey: 'app.home.destinations.autopilot_devices.description',
    routerLink: ['/autopilot-devices'],
    permission: [PERMISSIONS.AUTOPILOT_DEVICES_READ, PERMISSIONS.AUTOPILOT_DEVICES_IMPORT],
    entitlement: 'autopilot',
  },
  {
    key: 'autopilot_history',
    icon: 'history',
    labelKey: 'app.home.destinations.autopilot_history.title',
    descriptionKey: 'app.home.destinations.autopilot_history.description',
    routerLink: ['/autopilot-devices', 'history'],
    permission: PERMISSIONS.AUTOPILOT_DEVICES_IMPORT,
    entitlement: 'autopilot',
  },
  {
    key: 'reports',
    icon: 'bar_chart',
    labelKey: 'app.home.destinations.reports.title',
    descriptionKey: 'app.home.destinations.reports.description',
    routerLink: ['/reports'],
    permission: REPORTS_PERMISSIONS,
    entitlement: 'reports',
  },
  {
    key: 'anomalies_report',
    icon: 'monitor_heart',
    labelKey: 'app.home.destinations.anomalies_report.title',
    descriptionKey: 'app.home.destinations.anomalies_report.description',
    routerLink: ['/reports', 'anomalies'],
    permission: PERMISSIONS.ANOMALIES_REPORT,
    entitlement: 'reports',
  },
  {
    key: 'entra_admin_roles_report',
    icon: 'admin_panel_settings',
    labelKey: 'app.home.destinations.entra_admin_roles_report.title',
    descriptionKey: 'app.home.destinations.entra_admin_roles_report.description',
    routerLink: ['/reports', 'entra-admin-roles'],
    permission: PERMISSIONS.ENTRA_ADMIN_REPORT,
    entitlement: 'reports',
  },
  {
    key: 'm365_license_report',
    icon: 'badge',
    labelKey: 'app.home.destinations.m365_license_report.title',
    descriptionKey: 'app.home.destinations.m365_license_report.description',
    routerLink: ['/reports', 'm365-license-assignment'],
    permission: PERMISSIONS.M365_LICENSE_REPORT,
    entitlement: 'reports',
  },
  {
    key: 'team',
    icon: 'manage_accounts',
    labelKey: 'app.home.destinations.team.title',
    descriptionKey: 'app.home.destinations.team.description',
    routerLink: ['/settings', 'users'],
    permission: PERMISSIONS.USER_READ,
  },
  {
    key: 'invite_teammate',
    icon: 'person_add',
    labelKey: 'app.home.destinations.invite_teammate.title',
    descriptionKey: 'app.home.destinations.invite_teammate.description',
    routerLink: ['/settings', 'users', 'add'],
    permission: PERMISSIONS.USER_CREATE,
    alsoRequires: PERMISSIONS.USER_READ,
  },
  {
    key: 'roles',
    icon: 'key',
    labelKey: 'app.home.destinations.roles.title',
    descriptionKey: 'app.home.destinations.roles.description',
    routerLink: ['/settings', 'roles'],
    permission: PERMISSIONS.ROLE_READ,
    entitlement: 'rbac',
  },
  {
    key: 'licences',
    icon: 'workspace_premium',
    labelKey: 'app.home.destinations.licences.title',
    descriptionKey: 'app.home.destinations.licences.description',
    routerLink: ['/settings', 'licences'],
    permission: PERMISSIONS.LICENSE_MANAGE,
  },
  {
    key: 'billing',
    icon: 'receipt_long',
    labelKey: 'app.home.destinations.billing.title',
    descriptionKey: 'app.home.destinations.billing.description',
    routerLink: ['/settings', 'billing'],
    permission: PERMISSIONS.BILLING_MANAGE,
  },
];

export const HOME_LAUNCHER_KEYS: readonly string[] = [
  'invite_teammate',
  'devices',
  'users',
  'autopilot_devices',
  'anomalies_report',
  'licences',
  'roles',
  'billing',
];
